import request from "@/utils/request";
export type { V2Validator } from "@/types/network";

export const mintValidatorPublic = async (data: {
  walletAddress: string;
  tier: 2;
  depositChainId: number;
  depositTransactionHash: string;
}): Promise<{
  mintId: string;
  result: string;
}> => {
  // @ts-ignore
  return await request.rpc("validator/mintValidatorPublic", data, {
    endpoint: "network",
  });
};

export const mintValidatorPrivate = async (data: {
  walletAddress: string;
  depositChainId: number;
  depositTransactionHash: string;
}): Promise<{
  mintId: string;
  result: string;
}> => {
  // @ts-ignore
  return await request.rpc("validator/mintValidatorPrivate", data, {
    endpoint: "network",
  });
};

export const getTxStatusfromMintId = async (data: {
  mintId: string;
}): Promise<{
  txHash: string;
  status: "offchain" | "pending" | "failed" | "success";
}> => {
  // @ts-ignore
  return await request.rpc("validator/getTxStatusfromMintId", data, {
    endpoint: "network",
  });
};

export const getTxHashfromMintId = async (data: {
  mintId: string;
}): Promise<{
  transactionHash: string;
}> => {
  // @ts-ignore
  return await request.rpc("validator/getTxHashfromMintId", data, {
    endpoint: "network",
  });
};

export type Validator = {
  tier: string;
  validatorName: string | null;
  tokenId: string;
  karatScore: number;
  referralNumber: number;
  referralLink: string;
  imageUrl: string;
  ownerAddress: string;
  stake: {
    stakedAmount: string;
    percentageOfNetwork: number;
    apy: number;
    stakerAmount: number;
  };
};

export type Claimer = {
  role: string;
  tokenId: string;
  karatScore: string;
  referralLink: string;
  referralNumber: string;
  imageUrl: string;
  ownerAddress: string;
  referralScore: string;
};

export type SortType = "asc" | "desc" | "ASC" | "DESC";
export type SortKey =
  | "karatScore"
  | "tokenId"
  | "apy"
  | "stakedAmount"
  | "earnings"
  | "stakerAmount"
  | "lastDayReturn";

export const getValidatorFromGraph = async (data: {
  current?: number;
  pageSize?: number;
  sortType?: SortType;
  sort?: string;
}): Promise<{
  list: Validator[];
  nextPage?: number;
  pageNum: number;
}> => {
  // @ts-ignore
  return await request.rpc("validator/getValidatorFromGraph", data, {
    endpoint: "network",
  });
};

export const getLieutenantFromGraph = async (data: {
  current?: number;
  pageSize?: number;
  sortType?: SortType;
  sort?: string;
}): Promise<{
  list: Claimer[];
  nextPage?: number;
  pageNum: number;
}> => {
  // @ts-ignore
  return await request.rpc("validator/getLieutenantFromGraph", data, {
    endpoint: "network",
  });
};
